// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"faq-accordion_sectionTitle__FA_rk","faqSection":"faq-accordion_faqSection__F5Rs0"};